export default {
  app: {
    label: {
      add: 'Add',
      create: 'Create',
      edit: 'Edit',
      copy: 'Copy',
      save: 'Save',
      delete: 'Delete',
      ok: 'OK',
      cancel: 'Cancel',
      choose: 'Choose',
      close: 'Close',
      reset: 'Reset',
      login: 'Login',
      logout: 'Logout',
      action: 'Action | Actions',
      assign: 'Assign',
      search: 'Search',
      import: 'Import',
      export: 'Export',
      detail: 'Detail | Details',
      type: 'Type | Types',
      group: 'Group | Groups',
      instance: 'Instance | Instances',
      all: 'All',
      admin: 'Admin',
      percent: 'Percent',
      validate: 'Validate',
      next: 'Next',
      previous: 'Previous',
      summary: 'Summary',
      null: 'Null',
      yes: 'Yes',
      no: 'No',
      none: 'None',
      inactive: 'Inactive',
      options: 'Options',
      locale: {
        en: 'English',
        fr: 'French',
      },
    },
    tip: {
      empty_list: 'The list is empty, click to add',
      select_for_questions: 'Please make a selection to see the questions',
    },
    title: {
      add: 'New {0}',
      edit: 'Edit {0}',
    },
  },

  $vuetify: {
    dataTable: {
      itemsPerPageText: 'Rows per page:',
      sortBy: 'Sort By',
      ariaLabel: {
        sortNone: '@:app.label.none',
        activateAscending: 'Activate Ascending',
        activateDescending: 'Activate Descending',
        sortAscending: 'Sort Ascending',
        sortDescending: 'Sort Descending',
        activateNone: 'Activate None',
      },
    },
    dataIterator: {
      noResultsText: 'No Results',
      loadingText: 'Loading... Please wait',
    },
    dataFooter: {
      pageText: '{0} - {1} of {2}',
      itemsPerPageAll: 'All',
      nextPage: '@:app.label.next',
      prevPage: '@:app.label.previous',
    },
    noDataText: 'No Data',
    close: '@:app.label.close',
  },

  validation: {
    error: {
      default: 'There was an error',
      required: 'Value is required',
      date: 'Invalid date, must be in the format: YYYY-MM-DDTHH:mm:ssZ',
      unique: 'Value is not unique',
      email: 'Value is not a valid email address',
      confirmed: 'Value has not been confirmed',
      password:
        'This field is mandatory and must contain 8 characters at minimum including at least a digit, a lower-case letter and an upper-case letter.',
      regex: 'Value is invalid',
      url: 'Invalid URL',
    },
    success: {
      add: '{0} has been added',
      default: '{0} has been updated',
      delete: '{0} has been deleted',
      copy: '{0} has been copied',
    },
    confirmation: {
      delete: 'Are you sure you want to delete {0}?',
      surveyGroup: {
        activate: 'Do you want to activate all surveys within {0}?',
        deactivate: 'Do you want to deactivate all surveys within {0}?',
        close: 'Do you want to close all surveys within {0}?',
        archived: 'Do you want to archive all surveys within the survey group?',
        particpants: 'Not submitted participants: ',
      },
      navigation:
        'There is unsaved changes to the current page that will be lost. Continue without saving?',
    },
  },

  navigation: {
    dashboard: 'Home',
    help: 'Help',
    contactus: 'Contact Us',
    system: 'System Management',
    deployment: 'Deployment',
  },

  model: {
    common: {
      id: 'ID',
      email: 'Email',
      name: 'Name',
      label: 'Label | Labels',
      state: 'State',
      type: 'Type',
      scope: 'Scope',
      parent: 'Parent',
      children: 'Child | Children',
      date: 'Date',
      createddate: 'Created Date',
      opendate: 'Open Date',
      startdate: 'Start Date',
      closedate: 'Close Date',
      enddate: 'End Date',
      submitteddate: 'Submitted Date',
      completeddate: 'Completed Date',
      text: 'Text',
      key: 'Key | Keys',
      title: 'Title',
      description: 'Description',
      participantCount: 'Participants Count',
      dueDate: 'Due Date',
      total: 'Total',
      active: 'Active',
    },
    address: {
      line1: 'Address - Line 1',
      line2: 'Address - Line 2',
      unit: 'Unit Number',
      streetnumber: 'Street Number',
      streetaddress: 'Street',
      pobox: 'P.O. Box',
      city: 'City',
      province: 'Province',
      postalcode: 'Postal Code',
    },
    user: {
      label: 'User | Users',
      lastname: 'Last Name',
      firstname: 'First Name',
      username: 'Username',
      password: 'Password',
      permission: 'Permission | Permissions',
      lastlogin: 'Last Login',
      language: 'Preferred Language',
    },
    role: {
      label: 'Role | Roles',
      sp_privs: 'Service Provider Privileges',
      oversight_privs: 'Oversight Organization Privileges',
      oversight_children_privs: 'Children Oversight Organization Privileges',

      type: {
        label: '@:model.common.type',
        oversight: '@:model.oversightOrganization.label',
        serviceprovider: '@:model.serviceProvider.label',
        superadmin: 'Super Admin',
        admin: '@:app.label.admin',
      },

      privileges: {
        readonly: 'Readonly',
        admin: '@:app.label.admin',
        accompany: 'Accompany',
        sub_org: '@:model.survey.suborg',
      },
    },
    oversightOrganization: {
      label: 'Oversight Organization | Oversight Organizations',
    },
    oversightOrganizationType: {
      label: 'Oversight Organization Type | Oversight Organization Types',
      childType: 'Children Type',
      childOversightOrganizationType: 'Children Oversight Organization Type',
      childExclusive: 'Mutually Exclusive Children',
    },
    serviceProvider: {
      label: 'Service Provider | Service Providers',
      parentOversight: 'Parent Oversight Organization',
    },
    serviceProviderType: {
      label: 'Service Provider Type | Service Provider Types',
    },
    automated: {
      email: {
        label: 'Automated Email | Automated Emails',
        subject: 'Subject',
        usedefaultSignature: 'Use Default Signature',
        defaultSignature: 'Default Signature',
        signature: 'Signature | Signatures',
        body: 'Body',
        system: 'System Email',
        emailCount: 'Email Count',
        userCount: 'User Count',
        multi: 'Multi',
        multilingual: 'Multilingual content',
      },
    },
    survey: {
      label: 'Survey | Surveys',
      defaultstate: 'Default Survey State',
      organization: 'Organization',
      suborg: 'Sub Organization',
      pointofservice: 'Point of Service',
      options: {
        documents: {
          text: '@:model.document.label',
          value: 'Activate document library',
        },
      },
    },
    surveyGroup: {
      label: 'Survey Group | Survey Groups',
      includeArchived: 'Include Archived Groups',
    },
    surveyParticipation: {
      label: 'Participation | Participants',
      submissionstate: 'Submission State',
      progress: 'Progression',
    },
    surveyState: {
      label: 'State | States',
      category: 'Category',
      editablebysp: 'Editable by Service Provider',
      editablebyoversight: 'Editable by Oversight Organization',
      spemailkey: 'Email to Service Provider',
      oversightemailkey: 'Email to Oversight Organization',
      to_label: 'Button label to reach this state',
      nextstate: {
        label: 'Next State',
        serviceprovider: 'Service Provider Next States',
        oversight: 'Oversight Organization Next States',
      },
    },
    question: {
      label: 'Question | Questions',
      questionnumber: 'Short Question Number',
      fullquestionnumber: 'Full Question Number',
      condition: {
        label: 'Condition',
        key: 'Condition Key',
        answers: 'Answers',
        text: 'Conditional',
        noQuestions: 'No questions are currently visible',
      },
      shorttext: 'Short Text',
      longtext: 'Long Text',
      helptext: 'Help Text',
      permission: {
        label: '@:model.user.permission',
        visible: 'Visible',
        editable: 'Editable',
      },
      type: {
        clientele: 'Clientele',
        contact_information: 'Contact Information',
        date: 'Date',
        human_resources: 'Human Resources',
        likert: 'Likert',
        long_text: 'Long Text',
        mailing_address: 'Mailing Address',
        multiple_choice: 'Multiple Choice',
        multiple_choice_data_set: 'Multiple Choice (Data Set)',
        points_of_service: 'Points of Service',
        rich_text: 'Rich Text',
        short_text: 'Short Text',
        sub_organization: 'Sub Organization',
        table_format: 'Table Format',
        text_block: 'Text Block',
      },
      options: {
        label: '@:app.label.options',
        common: {
          indentation: 'Indentation',
          header: {
            visible: 'Show Question Header',
          },
          documents: {
            visible: 'Allow documents as attachments',
          },
          notes: 'Additionnal Notes',
        },
        summary: {
          progress: 'Survey Progress',
          state: {
            validation: 'Are you sure that the state should change to {0}?',
            currentProgress: 'The current Survey progress is: {0}%',
            success: 'State was changed',
          },
        },
        human_resources: {
          source: 'Source',
          positioncounttype: 'Position Count Type',
          resource: 'Resource',
          department: {
            active: 'Active the "Department" field',
            label: 'Department Label',
            labelDefault: 'Department',
          },
          position: {
            active: 'Activate the "Position" field',
            label: 'Label of the "Position" field',
            labelDefault: 'Position',
            useDataset: 'Recommend values from dataset',
            dataset: '@:model.dataset.label',
          },
          language: {
            total: 'Total',
            totalfte: 'FTE Total',
            totaldp: 'Total DP',
            dbpfilledwith: 'DBP filled with lang. prof.',
            dbpfilledwithout: 'DBP filled without lang. prof.',
            vacant: 'Vacant positions',
            nondbp: 'Bilingual in other positions',
          },
        },
        likert: {
          showUnknown: 'Show Unknown Option',
          showNotes: 'Show @:model.question.options.common.notes',
          primary: 'Primary Question',
          showPrimary: 'Show Primary Question',
          noterows: '@:model.question.options.common.notes Rows',
          language: {
            primary: {
              true: {
                label: 'True Label',
                default: '@:app.label.yes',
              },
              false: {
                label: 'False Label',
                default: '@:app.label.no',
              },
              unknown: {
                label: 'Unknown Label',
                default: 'Unknown',
              },
            },
            secondary: {
              question: {
                label: 'Secondary Question Label',
              },
            },
            notes: {
              label: '@:model.question.options.common.notes Label',
              default: '@:model.question.options.common.notes',
            },
          },
          secondary: {
            options: {
              text: '@:model.common.text',
              acronym: 'Acronym',
              key: '@:model.common.key',
              score: 'Score',
            },
          },
        },
        longText: {
          rows: 'Rows',
        },
        multiple_choice: {
          choices: {
            key: '@:model.common.key',
            text: '@:model.common.text',
          },
          type: '@:app.label.type',
          multiple: 'Multiple Select',
          other: {
            option: '"Other" option',
            checkbox: 'Other',
            label: '"Other" Label',
            default: 'Please specify',
          },
          notes: {
            checkbox: 'Free-text notes field',
            label: '"Notes" Label',
            default: 'Additionnal Notes',
          },
          sort: 'Sorting order',
          displayalloptions: 'Show All Options on Readonly',
        },
        multiple_choice_data_set: {
          dataset: '@:model.dataset.label',
          type: {
            label: '@:model.common.type',
            enforce: 'Enforce',
            guideline: 'Guideline',
          },
          multiple: {
            label: 'Choice selection',
            true: 'Multiple Selections',
            false: 'Single Selection',
          },
          label: {
            label: 'Picker Label',
          },
        },
        clientele: {
          percentage: {
            label: 'Percentage of Francophones Label',
            default: 'Percentage of Francophones',
          },
          period: {
            label: 'Period Label',
            default: 'Year',
          },
          totalvisit: {
            label: 'Total Visits Label',
            default: 'Total Visits',
          },
          francophonevisit: {
            label: 'Francophone Visits Label',
            default: 'Francophone Visits',
          },
          totalclients: {
            label: 'Total Clients Label',
            default: 'Total Clients',
          },
          francophoneclients: {
            label: 'Francophone Clients Label',
            default: 'Francophone Clients',
          },
        },
        points_of_service: {
          address: 'Show Address Input',
          singlelabel: {
            label: 'Single Label',
            default: 'Single',
          },
          multilabel: {
            label: 'Multiple Label',
            default: 'Multiple',
          },
        },
        short_text: {
          options: {
            rules: {
              label: 'Rule',
              none: '@:app.label.none',
              regex: 'Regex',
              email: 'Email',
              url: 'URL',
            },
            errorMessage: 'Custom Error Message',
          },
        },
        sub_organization: {
          singlelabel: {
            label: 'Single Label',
            default: 'Single',
          },
          multilabel: {
            label: 'Multiple Label',
            default: 'Multiple',
          },
        },
        table_format: {
          header: 'Column Header',
          question: '@:model.question.label',
        },
        text_block: {
          text: 'Extra Text',
        },
        contact_information: {
          firstname: '@:model.user.firstname',
          lastname: '@:model.user.lastname',
          initial: 'Initial',
          title: 'Title',
          email: 'Email',
          phone: 'Phone Number',
          extension: 'Ext.',
        },
      },
      validation: {
        label: 'Validation',
        mandatory: {
          label: 'Response obligation',
          options: {
            none: 'Not Mandatory',
            soft: 'Soft Mandatory (Shows on Progress)',
            submit: 'Mandatory (Blocks Submission)',
          },
        },
      },
    },
    page: {
      label: 'Page | Pages',
      shortname: 'Short Name',
      longname: 'Long Name',
      level: 'Level',
    },
    section: {
      label: 'Section | Sections',
      toc: 'Table of Contents',
    },
    log: {
      label: 'Log | Logs',
      surveyName: 'Survey Name',
      serviceProviderName: 'Service Provider Name',
      questionKey: 'Question Key',
      requestPayload: 'Request Payload',
      callerIP: 'Caller IP',
      callerBrowser: 'Caller Browser',
    },
    email: {
      label: 'Email | Emails',
    },
    functionalcenter: {
      label: 'Functional Center | Functional Centers',
      code: 'Code',
    },

    worksheet: {
      label: 'Worksheet | Worksheets',
      name: '@:model.common.name',
      active: '@:model.common.active',
      layout: {
        label: '@:page.survey.details.layoutTab',
        header: {
          label: 'Worksheet Item',
          name: 'Column Name',
          question: '@:model.question.label',
        },
      },
    },

    document: {
      label: 'Document | Documents',
      file: 'File',
      name: '@:model.common.name',
      description: '@:model.common.description',
      associations: '@:model.question.label',
      uploaddate: 'Upload Date',
    },

    bookshelf: {
      label: 'Bookshelf | Bookshelves',
      name: '@:model.common.name',
      notes: 'Admin Notes',
      layout: {
        label: 'Layout',
        type: '@:model.common.type',
        content_type: 'Content Type',
        title: '@:model.common.title',
        description: '@:model.common.description',
        value: {
          url: 'Url',
          text: 'Text',
        },
        options: {
          collapsed: 'Collapsed by default',
        },
        children: '@:model.common.children',
        language: {
          label: 'Language',
          any: 'Any',
        },
      },
    },

    resource: {
      label: 'Resource | Resources',
      name: '@:model.common.name',
      file: '@:model.document.file',
    },

    deployment: {
      label: 'Deployment',
      name: '@:model.deployment.label',
      version: {
        label: 'Version'
      },
      contactInfo: {
        label: 'Contact Information'
      },
    },

    dataset: {
      label: 'Data Set | Data Sets',
      key: '@:model.common.key',
      name: '@:model.common.name',
      oversighttype: '@:model.oversightOrganizationType.label',

      content: {
        label: 'Data Set Content',
        id: '@:model.common.id',
        key: '@:model.common.key',
        name: '@:model.common.name',
        oversights: '@:model.oversightOrganization.label',
      },
    },

    dashboard: {
      label: 'Dashboard',
      canvas: {
        label: 'Canvas',
        left: 'Left',
        right: 'Right',
      },
      tile: {
        label: 'Dashboard',
        type: {
          label: '@:model.common.type',
          bookshelf: '@:model.bookshelf.label',
          likert_score: 'Likert Score',
          multiple_choice_frequency: 'Multiple Choice Frequency',
          notifications: 'Notifications',
          my_surveys: "My Surveys",
          submission_status: 'Submission Status',
          survey_progress: 'Survey Progress',
        },

        bookshelf: {
          bookshelf: '@:model.bookshelf.label',
        },

        likert_score: {
          denominator: {
            label: 'Denominator',
            answercount: 'Total responses',
            netcount: 'Total questions',
          },
        },

        multiple_choice_frequency: {
          style: {
            label: 'Chart Style',
            aggregate: 'Aggregate',
            stack: 'Stack',
            group: 'Group',
          },
        },
      },
    },

    useragreement: {
      label: 'User Agreement | User Agreements',
      name: '@:model.common.name',
      text: '@:model.common.text',
      checkboxlabel: 'Checkbox Text',
      active: '@:model.common.active',
    },

    notification: {
      label: 'Notification | Notifications',
      name: '@:model.common.name',
      text: '@:model.common.text',
      datepublished: 'Date Published',
    },
  },

  page: {
    user: {
      list: {
        title: 'List of Users',
      },
      add: {
        title: 'Add User',
        submitAndEmail: 'Save and Send Email',
      },
      details: {
        title: 'User Details',
        resetPassword: {
          label: 'Reset Password',
          generate: 'Generate',
          setResetPasswordState: 'Force password change on next login',
          success: 'User password has been changed',
        },
        sendEmail: {
          label: 'Send Email',
          success: 'An email has been sent to the user',
        },
      },
    },

    login: {
      forgotPassword: 'Forgot password?',
      emailOrUsername: 'Email or Username',
      forgotPasswordInstructions:
        'Please enter your email or your username below and we will send you the instructions to reset your password',
      toLogin: 'Back to Login',
      resetPassword: 'Reset Password',
      forgotPasswordEmailSent:
        'An email has been sent with information to reset your password',
      resetPasswordInstructions:
        'You must reset your password to continue',
      resetPasswordSuccess: 'Password updated successfully',
      chooseRole: 'Choose a role',
    },

    profile: {
      title: 'Update Profile',
      details: {
        navigation: 'Profile',
        personal: 'Personal Information',
      },
      email: {
        navigation: 'Email',
        currentEmail: 'Your current email is: {email}',
        newEmail: 'New Email',
      },
      password: {
        navigation: 'Password',
        password: {
          old: 'Old Password',
          new: 'New Password',
          confirm: 'Confirm New Password',
        },
      },
    },

    dashboard: {
      oversight: {
        title: '@:navigation.dashboard',
      },
      provider: {
        title: '@:navigation.dashboard',
        survey: {
          view: 'View @:model.survey.label',
        },
      },

      tile: {
        type: {
          likert_score: {
            title: '@:model.common.title',
            scorelabel: 'Score Axes Label',

            gradients: {
              label: 'Colour',
              start: 'Start',
              middle: 'Middle',
              end: 'End',
            },

            questions: {
              label: '@:model.question.label',
              key: '@:model.common.key',
              display: 'Display Name',
            },

            scores: {
              label: 'Scores',
              score: 'Score',
              display: 'Display Name',
            },
          },

          multiple_choice_frequency: {
            title: '@:model.common.title',
            xaxes: 'X Axes Label',
            yaxes: 'Y Axes Label',
            stack: 'Stack Questions',
            horizontal: 'Horizontal orientation',
            questions: {
              label: '@:model.question.label',
              key: '@:model.common.key',
              display: 'Display Name',
            },
            answers: {
              label: 'Responses',
              key: '@:model.common.key',
              display: 'Display Name',
            },
          },

          submission_status: {
            title: '@:model.common.title',
            notstarted: 'Not Started',
            notsubmitted: 'Not Submitted',
            submitted: 'Submitted',
            complete: 'Complete',
          },
        },
      },
    },

    role: {
      list: {
        title: 'List of Roles',
      },
      add: {
        title: 'Add Role',
      },
      details: {
        title: 'Role Details',
        notes: 'Admin Notes',
      },
    },

    oversightOrganization: {
      add: {
        title: 'Add Oversight Organization',
      },
      details: {
        title: 'Oversight Organization Details',
      },
    },

    oversightOrganizationType: {
      add: {
        title: 'Add Oversight Organization Type',
      },
      details: {
        title: 'Oversight Organization Type Details',
      },
    },

    serviceProvider: {
      list: {
        showInactive: 'Show inactive entries',
      },
      add: {
        title: 'Add Service Provider',
      },
      details: {
        title: 'Service Provider Details',
      },
      changeState: {
        title: 'Change Service Provider State',
        success: 'State updated successfully',
        activate: 'Activate',
        deactivate: 'Deactivate',
        usersList: 'The following users will be affected:',
        surveyList: 'The following survey participations will be affected:',
      },
    },

    serviceProviderType: {
      add: {
        title: 'Add Service Provider Type',
      },
      details: {
        title: 'Service Provider Type Details',
      },
    },

    survey: {
      add: {
        title: 'Add Survey',
      },
      details: {
        title: 'Survey',
        layoutTab: 'Layout',
        previewTab: 'Preview',
        organizationNomenclature: 'Organization Nomenclature',
        options: '@:app.label.options',
      },
      participants: {
        bulkEdit: 'Bulk Edit',
        title: 'Participation Options',
        copy: {
          title: 'Copy Answers',
        },
      },
      questions: {
        used: 'Used',
      },
      duplicateHelp:
        'This will create a new survey with the following information and will copy all data from the selected survey (sections, questions, layout, participants, etc...)',
      report: {
        contents: 'Table of Contents',
        downloadPDF: 'Download PDF',
        downloadInProgress: 'The download will start soon',
      },
      validate: {
        success: 'Survey is valid',
        error: 'Survey is invalid',
      },
    },

    surveyGroup: {
      add: {
        title: 'Add Survey Group',
      },
      details: {
        title: 'Survey Group Details',
      },
    },

    automatedEmails: {
      add: {
        title: 'Add Automated Email',
      },
      details: {
        title: 'Automated Emails Details',
      },
      send: {
        title: 'Send Emails',
        submit: '@:page.automatedEmails.send.title',
        test: 'Send Test Email',
        validation: {
          success: 'Emails have been sent',
          test: 'Email sent to your email address',
        },
      },
    },

    document: {
      upload: 'Upload a Document',
      management: 'Document Management',
      linkedTo: 'Select Documents linked to {0}',
      bulkDownload: 'Bulk Download',
      showAll: 'Show All Documents',
    },

    bookshelf: {
      add: {
        title: 'Add Bookshelf',
      },
      edit: {
        title: 'Edit Bookshelf',
      },
    },

    dataset: {
      create: {
        title: 'Add Data Set',
      },
      edit: {
        title: 'Edit Data Set',
      },
      validate: {
        invalidJSON: 'JSON is invalid',
        import: 'Import Successful',
      },
      notEditable: 'Content cannot be changed until Data Set is saved',
      import: {
        file: '@:model.document.file',
        mode: {
          label: 'Import Mode',
          ignoreduplicate: 'Ignore Duplicates',
          purge: 'Purge',
        },
      },
    },

    useragreement: {
      add: {
        title: 'Add Agreement',
      },

      edit: {
        title: 'Edit Agreement',
      },
    },

    notification: {
      add: {
        title: 'Add Notification',
      },

      edit: {
        title: 'Edit Notification',
        publish: 'Publish',
        confirmPublish: 'Are you sure you want to publish this notification?',
      },

      validate: {
        publish: 'Notification Published',
      },
    },

    contactInfo: {
      contactLogin: {
        title: 'Login Page Contact Information',
        description: 'This will appear on the login page'
      },
      contactMenu: {
        title: 'Main Menu Contact Information',
        description: "This will appear on the main menu, under 'Home'"
      },
    },
  },
};
